import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-grupo-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit{

  @ViewChild('nivel') nivel: ElementRef;
  dato: FormGroup;
  tieneid;
  tamano = document.body.clientHeight;
  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.tieneid = params['id'];
    });

    this.dato = this.fb.group({ 
      id: [""],
      identificador: ['', [Validators.required]],
      nivel: [1, [Validators.required]],
      periodos_escolares_id: ["", [Validators.required]],
      carreras_planes_id: ["", [Validators.required]],
      turnos_id: ["", [Validators.required]],
      capacidad: [30, [Validators.required]],
      en_campania: [0, [Validators.required]],
      observaciones: [""],
      contado: [0],
      total_hombres_inicio: [""],
      total_mujeres_inicio: [""],
      continuado: [0]
    });

    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();

  }

  cambiaNivel(){
    let nivel : number = this.dato.controls.nivel.value;
    this.dato.controls.en_campania.patchValue(0);
    if (nivel>=2) {
      this.dato.controls.en_campania.patchValue(0);
    }
  }

}
